import React from 'react';

import './styles.css';

export const COMPLETED = 'Completed';
export const PENDING = 'Pending';

interface RoomCheckStatusTagProps {
  status: string;
}

const STATUS_TO_COLOR_MAPPER = {
  [COMPLETED]: {
    backgroundColor: 'var(--apple)',
    textColor: 'var(--white)'
  },
  [PENDING]: {
    backgroundColor: 'var(--pale-orange)',
    textColor: 'var(--black)'
  }
};

const RoomCheckStatusTag = ({status}: RoomCheckStatusTagProps) => {
  const {backgroundColor, textColor} = STATUS_TO_COLOR_MAPPER[status];

  return (
    <div
      className="RoomCheckStatusTag colab-centered colab-bold"
      style={{
        backgroundColor,
        color: textColor
      }}>
      {status}
    </div>
  );
};

export default RoomCheckStatusTag;
